import { render, staticRenderFns } from "./user-bio-4.vue?vue&type=template&id=73cc299c&scoped=true"
import script from "./user-bio-4.vue?vue&type=script&lang=js"
export * from "./user-bio-4.vue?vue&type=script&lang=js"
import style0 from "./user-bio-4.vue?vue&type=style&index=0&id=73cc299c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc299c",
  null
  
)

export default component.exports